import utils from './common';

function getDateDiffInDays(a, b) {
  // const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
  // const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
  // return Math.ceil((utc2 - utc1) / millisecondsPerDay);

  const millisecondsPerDay = 1000 * 60 * 60 * 24;

  const diffTime = Math.abs(b - a);
  return Math.ceil(diffTime / millisecondsPerDay);
}

function getDateLabel(dateStart, dateFinish, dateStop, isCompleted) {
  if (isCompleted) return '';

  const today = new Date((new Date()).setHours(0, 0, 0, 0));

  if (dateStop) {
    return `Завершено ${utils.convertDateToString(dateStop)}`;
  }

  if (dateStart) {
    const start = new Date(dateStart.setHours(0, 0, 0, 0));
    if (start > today) {
      const diff = getDateDiffInDays(start, today);
      const diffStr = utils.pluralWord(diff, 'день', 'дня', 'дней');
      return `${diffStr} до старта`;
    }
  }

  if (dateFinish) {
    const finish = new Date(dateFinish.setHours(0, 0, 0, 0));

    if (finish >= today) {
      const diff = getDateDiffInDays(today, finish) + 1;
      const diffStr = utils.pluralWord(diff, 'день', 'дня', 'дней');
      const prefix = utils.pluralWordPure(diff, 'Остался', 'Осталось', 'Осталось');
      return `${prefix} ${diffStr}`;
    }

    const diff = getDateDiffInDays(finish, today);
    const diffStr = utils.pluralWord(diff, 'день', 'дня', 'дней');
    return `Просрочено на ${diffStr}`;
  }

  return '';
}

function getProgress(dateStart, dateFinish) {
  if (!dateFinish || !dateStart) {
    return 0;
  }

  const now = new Date();

  if (now > dateFinish) {
    return 100;
  }

  if (now < dateStart) {
    return 0;
  }

  const total = dateFinish - dateStart;
  const passed = now - dateStart;
  const progress = passed / total;
  return Math.round(progress * 100);
}

function validateDate(dateIso) {
  if (!dateIso) {
    return null;
  }

  const date = new Date(dateIso);

  if (!date.getDate()) {
    return null;
  }

  return date;
}

export default function dateProgress(
  dateStartIso,
  dateFinishIso,
  dateStopIso = null,
  withTime = false,
  isCompleted = false,
) {
  const start = validateDate(dateStartIso);
  const finish = validateDate(dateFinishIso);
  const stop = validateDate(dateStopIso);

  return {
    dateStartIso,
    dateFinishIso,
    withTime,
    startText: utils.convertDateToString(start, 'short', withTime) || 'Без даты',
    finishText: utils.convertDateToString(finish, 'short', withTime) || 'Без даты',
    value: getProgress(start, finish),
    label: getDateLabel(start, finish, stop, isCompleted),
    startIcon: 'start',
    finishIcon: 'finish',
  };
}
